import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

import logoIcon from "../../assets/images/logo-icon.png";
import LockIcon from "../../assets/icons/auth-form/lock.png";
import { formTypes, authConstants } from "../../constants";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { authActions } from "../../redux/actions";

// Define the validation schema using Yup
const schema = Yup.object().shape({
  username: Yup.string().trim().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

const LoginForm = (props) => {
  const { login, spinnerActions } = props;
  // Use yupResolver to integrate Yup with React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema), // Use the Yup schema for validation
  });

  const [showPassword, setShowPassword] = useState(false);

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  const loginSuccessFunction = () => {
    props.closeModal();
    reset();
  };

  const onSubmit = (data) => {
    login(data, loginSuccessFunction);
  };

  const handleDisplayPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="login-form">
      <div className="row px-3 px-sm-0">
        <div className="col-12 col-lg-6 order-1 order-lg-0 mt-5 mt-lg-0 pt-5 pt-lg-0">
          <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column register-as-agent-container">
            <div className="sell-with-us-heading">Sell Property with Us</div>
            <RoundedButton
              className="auth-button px-4 py-2"
              onClick={() => props.changeFormType(formTypes.TYPE_AGENT_SIGNUP)}
            >
              Register as an Agent
            </RoundedButton>
          </div>
        </div>
        <div className="col-12 col-lg-6 order-0 order-lg-1 pt-5 pt-sm-0 sign-in-container">
          <div className="d-flex justify-content-center mb-5">
            <img src={logoIcon} alt="Bayview Shores" height={49} />
            <p className="login-brand-logo">Bayview Shores</p>
          </div>
          <form className="form" onSubmit={handleSubmit(onSubmit)}>
            <div className="sign-in-heading mb-4">Sign In</div>
            {/* Username Input */}
            <input
              className={`auth-form-input ${
                errors.username ? "is-invalid" : ""
              }`}
              placeholder="Username"
              {...register("username")}
            />
            {errors.username && (
              <div className="error">{errors.username.message}</div>
            )}
            {/* Password Input */}
            <div className="position-relative">
              <input
                className={`auth-form-input mt-4 pe-4 ${
                  errors.password ? "is-invalid" : ""
                }`}
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                {...register("password")}
              />
              {showPassword ? (
                <IoIosEye
                  className="position-absolute end-0 pointer login-password-icon"
                  onClick={handleDisplayPassword}
                />
              ) : (
                <IoIosEyeOff
                  className="position-absolute end-0 pointer login-password-icon"
                  onClick={handleDisplayPassword}
                />
              )}
            </div>
            {errors.password && (
              <div className="error">{errors.password.message}</div>
            )}

            <div
              className="d-flex justify-content-end align-content-center forgot-password mt-3 gap-2 pointer"
              onClick={() => props.changeFormType(formTypes.TYPE_FORGOT)}
            >
              <img src={LockIcon} alt="lock" />
              Forgot Password?
            </div>
            {/* Submit Button */}
            <div className="d-flex flex-column align-items-center w-100">
              <RoundedButton
                className="auth-button mx-auto w-100 py-2"
                cotainerClass="w-50 my-4"
                type="submit"
                disabled={spinner(authConstants.LOGIN) > -1}
              >
                {spinner(authConstants.LOGIN) > -1 ? "Verifying..." : "Sign In"}
              </RoundedButton>
              {/* Register Button */}
              <RoundedButton
                className="auth-button mx-auto bg-light border-light w-100 py-2"
                cotainerClass="w-50"
                onClick={() => props.changeFormType(formTypes.TYPE_REGISTER)}
              >
                Register
              </RoundedButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  login: (data, successFunction) =>
    dispatch(authActions.login(data, successFunction)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
